import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ArticlesRequestModel } from '../../../helpers/objects/request/articles/articles-request-model';
import { ArticlesResponseModel } from '../../../helpers/objects/response/articles/articles-response-model';
import { map, Observable } from 'rxjs';
import { ArticlesModel } from '../../../helpers/objects/dto/articles/articles-model';
import { BackofficeArticlesSetupModel } from '../../../helpers/objects/dto/backoffice/backoffice-articles/backoffice-articles-setup/backoffice-articles-setup-model';
import { BackofficeArticlesModel } from '../../../helpers/objects/dto/backoffice/backoffice-articles/backoffice-articles/backoffice-articles-model';

@Injectable({
  providedIn: 'root'
})
export class BackofficeArticlesService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(private http: HttpClient, @Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel) {
    this.appConfig = appConfigTemp;
  }

  get(filter: ArticlesRequestModel): Observable<ArticlesResponseModel> {
    const httpParams: HttpParams = new HttpParams({
      fromObject: filter as any
    });
    return this.http
      .get<any>(this.appConfig.api + 'backoffice/articles/' + this.appConfig.apiPartnershipId, {
        params: httpParams
      })
      .pipe(map((response) => response.body as ArticlesResponseModel));
  }

  getDetails(articleId: string): Observable<ArticlesModel> {
    return this.http.get<any>(this.appConfig.api + 'backoffice/articles/' + this.appConfig.apiPartnershipId + '/' + articleId).pipe(
      map((response) => {
        return response.body as ArticlesModel;
      })
    );
  }

  getSetup(): Observable<BackofficeArticlesSetupModel> {
    return this.http.get<any>(this.appConfig.api + 'backoffice/setup/articles/' + this.appConfig.apiPartnershipId).pipe(
      map((response) => {
        return response.body as BackofficeArticlesSetupModel;
      })
    );
  }

  edit(updatedArticle: BackofficeArticlesModel): Observable<any> {
    return this.http.put(this.appConfig.api + 'backoffice/articles/' + this.appConfig.apiPartnershipId, updatedArticle);
  }
  create(newArticle: BackofficeArticlesModel): Observable<any> {
    return this.http.post(this.appConfig.api + 'backoffice/articles/' + this.appConfig.apiPartnershipId, newArticle);
  }
}
